import { List, ListRootProps } from "@biblioteksentralen/react";
import { Limelight } from "next/font/google";
import { usePathname } from "next/navigation";
import { capitalize } from "radash";
import { useTranslation } from "../../utils/hooks/useTranslation";
import InternalLink from "../InternalLink";
import { SommerlesButton } from "./SommerlesButton";
import { getGradeLabel, getGradePath, grades } from "./sommerlesPopularReading";

const limelightFont = Limelight({ subsets: ["latin"], weight: "400" });

const SommerlesPopularReadingLinks = (props: ListRootProps) => {
  const { t } = useTranslation();
  const pathName = usePathname();

  return (
    <List.Root
      unstyled
      display="flex"
      flexDir="row"
      flexWrap="wrap"
      gap="0.5rem"
      width="100%"
      className={limelightFont.className}
      containerType="inline-size"
      css={{
        "& h1,h2": limelightFont.style,
      }}
      {...props}
    >
      {grades.map((grade) => {
        return (
          <List.Item key={grade}>
            <SommerlesButton disabled={pathName.endsWith(`${grade}`)} asChild>
              <InternalLink href={getGradePath(grade)}>{capitalize(getGradeLabel(grade, t))}</InternalLink>
            </SommerlesButton>
          </List.Item>
        );
      })}
    </List.Root>
  );
};

export default SommerlesPopularReadingLinks;
